import { Utils } from "@/plugins/utils"
import router from '@/router';

export default {
	namespaced: true,
	state: {
		cv5: null,
		lstItems: [],
		insert: false,
		update: false,
		loading: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getCv5(state) {
			return { ...state.cv5 }
		},
		getLstItems(state) {
			return state.lstItems
		},
	},
	mutations: {
		set(state, receivingViewModel) {
			state.cv5 = receivingViewModel.invoice
			state.lstItems = receivingViewModel.listReceivingItems || []
			if (receivingViewModel.invoice) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cv5 = null
			state.lstItems = []
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setCv5(state, cv5) {
			state.cv5 = cv5
		},
		setLstItems(state, lstItems) {
			state.lstItems = lstItems
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, { cv5doc, cv5tipo, cv5emissor }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`OryxPlace/MaterialReceiving/FindByFiscalId`, {
					params: { cv5doc, cv5tipo, cv5emissor }
				})
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					commit("set", data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					router.push("/oryxpdv")
					return
				})
			commit("setLoading", false)
		},

		async save({ commit, state, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)

			const payload = await this._vm.$axios
				.post("/OryxPlace/MaterialReceiving/SaveMaterialReceiving", {
					invoice: state.cv5,
					listReceivingItems: state.lstItems
				})
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			)

			return payload
		},
		
		async createCylinder({ dispatch }, item) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Criando cilindro", indeterminate: true }, { root: true })
			const payload = await this._vm.$axios
				.post("OryxPlace/MaterialReceiving/CreateCylinder", item)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async removeItem({ commit, state }, itemIndex) {
			const updated = state.lstItems.filter((_, i) => i !== itemIndex)
			commit("setLstItems", updated)
		},
	},
}
